import React from "react"
import moment from "moment"
import { Link, navigate } from "gatsby"

export default function BlogListingCard({ blog }) {
  const { slug, path, title, author, updatedAt } = blog

  function handleClick(e) {
    if (e.target.tagName === "H3") {
      console.log(`e.target`, e.target)
      return;
    }
    // navigate(path)
    window.open(path, '_blank').focus();
  }

  return (
    <div className="blog-listing--item" onClick={handleClick}>
      <div>
        <a href={`${path}`} target="_blank">
          <h3>{title}</h3>
        </a>
        <div className="blog-listing--item__summary">
          {author && (
            <div className="blog-listing--item__profile">
              <img src={author.avatar.fixed.src} alt="author" />
              <p>
                Author: <span>{author.name}</span>
              </p>
            </div>
          )}
          <div>
            <p>
              Last Updated: <span>{moment(updatedAt).format("M/DD/YYYY")}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
